import { useQuery } from '@tanstack/react-query';
import { waitForIDs } from 'app/copied/getIds';
import useArticles from 'app/modules/tailor/hooks/useArticles';
import fetchArticle from 'app/services/articles';

import { SuggestedEntry } from '../../copied/models/ChatModules';

export default function useFetchArticle(articleId: string) {
  const { articles, addArticle } = useArticles();

  return useQuery({
    queryKey: ['article', articleId],
    queryFn: async () => {
      let article = articles.find((article: SuggestedEntry) => article.id === articleId);

      if (article) {
        return Promise.resolve(article);
      }

      const { conditionId } = await waitForIDs();

      if (!conditionId) {
        return undefined;
      }

      article = await fetchArticle(conditionId, articleId);

      if (article) {
        addArticle(article);
      }

      return article;
    },
    enabled: !!articleId,
  });
}
